import React from 'react';

const chevronDown = (
  <svg
    aria-hidden="true"
    focusable="false"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 56 33"
  >
    <polyline points="
      3 3
      28 30
      53 3
    " />
  </svg>
);

const chevronRight = (
  <svg
    aria-hidden="true"
    focusable="false"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 33 56"
  >
    <polyline points="
      3 3
      30 28
      3 53
    " />
  </svg>
);

const chevronLeft = (
  <svg
    aria-hidden="true"
    focusable="false"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 33 56"
  >
    <polyline points="
      30 3
      3 28
      30 53
    " />
  </svg>
);

const gridSvg = (
  <svg
    aria-hidden="true"
    focusable="false"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 56 56"
    className="svg-grid"
  >
    <rect x="3" y="3" width="19" height="19"></rect>
    <rect x="31" y="3" width="19" height="19"></rect>
    <rect x="3" y="31" width="19" height="19"></rect>
    <rect x="31" y="31" width="19" height="19"></rect>
  </svg>
);

export {
  chevronDown,
  chevronRight,
  chevronLeft,
  gridSvg,
}